module.exports = __webpack_public_path__ + "90f98ff9672034102f7e4deaf677c9fd.svg";